module.exports = __webpack_public_path__ + "img/que-hacemos.9f02ee55.png";